import { motion } from "framer-motion";
import useIsMobile from "../../hooks/useIsMobile";
import Icon from "./Icon";
import Reveal from "./Reveal";
import { colors, fonts, maxW } from "../../styles/theme";

// Shared loading / empty / error treatment for sheet-backed pages
// (Careers, Blog) — no fake placeholder content, just an honest status.
export function SheetLoading({ label = "Loading…" }) {
  return (
    <motion.p
      initial={{ opacity: 0 }} animate={{ opacity: 1 }}
      transition={{ duration: 0.8, repeat: Infinity, repeatType: "reverse" }}
      style={{ color: colors.inkFaint, fontFamily: fonts.body, fontSize: 14, padding: "48px 4px" }}
    >
      {label}
    </motion.p>
  );
}

export function SheetEmpty({ icon = "Briefcase", title, message }) {
  const mob = useIsMobile();
  return (
    <Reveal style={{ ...maxW, textAlign: "center", border: `1px solid ${colors.border}`, borderRadius: 6, padding: mob ? "50px 24px" : "70px 40px" }}>
      <Icon name={icon} size={28} style={{ color: colors.rust, marginBottom: 18 }} />
      <h3 style={{ fontFamily: fonts.display, fontWeight: 600, fontSize: mob ? 21 : 25, color: colors.ink, marginBottom: 10 }}>{title}</h3>
      <p style={{ color: colors.inkFaint, fontFamily: fonts.body, fontSize: mob ? 14 : 15, lineHeight: 1.7, maxWidth: 420, margin: "0 auto" }}>{message}</p>
    </Reveal>
  );
}
